import { apiSlice } from "./apiSlice";
import isEmpty from 'lodash/isEmpty';

const prepareParams = function({ page = 1, perPage = 30, sortBy, globalFilter, filters }) {
  let params = { page: page, per_page: perPage };
  if (sortBy && sortBy[0]) {
    params.sort_by = sortBy[0].id;
    params.sort_desc = sortBy[0].desc;
  };
  if (globalFilter && globalFilter.length >= 3) {
    params.q = globalFilter
  }
  if (!isEmpty(filters)) {
    params.filters = JSON.stringify(filters.reduce((acc, filter) => {
      return {
        ...acc,
        [filter.id]: filter.value
      }
    }, {}))
  }
  return params;
}

export const pakitoApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPakito: builder.query({
      query: (params) => {
        return {
          url: '/pakitos',
          params: prepareParams(params)
        }},
      providesTags: (result = [], error, arg) => [{ type: 'Pakito', id: JSON.stringify(prepareParams(arg)) }],
    }),
    getPakitoApp: builder.query ({
      query: (id) => {
        return {
          url: `/pakitos/${id}`,
        }},
      providesTags: (result = [], error, arg) => [{ type: 'Pakito', id: arg }],
    }),
    getPakitoFilters: builder.query({
      query: () => ({
        url: '/pakitos/filters',
      })
    })
  }),
  overrideExisting: false
})

export const {
  useLazyGetPakitoQuery,
  useGetPakitoFiltersQuery,
  useGetPakitoAppQuery
} = pakitoApiSlice
